'use client';
import { faqs } from '~/components/constants/faqs';
import { Disclosure } from '@headlessui/react';
import { IconMinus, IconPlus } from '@tabler/icons-react';
import { Heading } from './ui/Heading';

export function FAQs() {
  return (
    <div className="mx-auto py-24 sm:py-32 lg:py-40">
      <div className="mx-auto grid grid-cols-1 divide-gray-900/10">
        <Heading>Frequently asked questions</Heading>

        <dl className="space-y-6 divide-y divide-gray-900/10">
          {faqs.map((faq) => (
            <Disclosure as="div" key={faq.question} className="hover:bg-primary/10 p-1">
              {({ open }) => (
                <>
                  <dt className="hover:bg-primary/10 p-2">
                    <Disclosure.Button className="flex w-full items-start justify-between text-left text-gray-900 dark:text-neutral-200">
                      <span className="text-base font-semibold leading-7">{faq.question}</span>
                      <span className="ml-6 flex h-7 items-center">
                        {open ? (
                          <IconMinus className="h-6 w-6" aria-hidden="true" />
                        ) : (
                          <IconPlus className="h-6 w-6" aria-hidden="true" />
                        )}
                      </span>
                    </Disclosure.Button>
                  </dt>
                  <Disclosure.Panel as="dd" className="mt-2 p-2 pr-12">
                    <div className="text-base leading-7 text-gray-600 dark:text-neutral-300">{faq.answer}</div>
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          ))}
        </dl>
      </div>
    </div>
  );
}
